export const GAME_440_RIGHT_ICON_PRODUCTS = [
  {
    productId: 'lap.app.pack11',
    cpProductId: '999000903',
    badgeKey: 'v3ProductLimitOnceBadge'
  },
  {
    productId: 'lap.app.pack37',
    cpProductId: '999000901',
    badgeKey: 'v3ProductWeeklyOnlyBadge'
  },
  {
    productId: 'lap.app.pack30',
    cpProductId: '999000902',
    badgeKey: 'v3ProductMonthlyOnlyBadge'
  }
];

export function isGame440RightIconProduct(item) {
  if (!item) {
    return false;
  }
  return GAME_440_RIGHT_ICON_PRODUCTS.some(
    product =>
      product.productId === item.PRODUCT_ID &&
      product.cpProductId === String(item.CP_PRODUCT_ID)
  );
}

export function getGame440RightIconBadgeKey(item) {
  const matchedProduct = GAME_440_RIGHT_ICON_PRODUCTS.find(
    product =>
      product.productId === item?.PRODUCT_ID &&
      product.cpProductId === String(item?.CP_PRODUCT_ID)
  );
  return matchedProduct?.badgeKey || '';
}

export function isGame440RightIconProductSoldOut(item) {
  return isGame440RightIconProduct(item) && +item.LIMIT === 0;
}

export function isGame440RightIconProductPinned(item) {
  return isGame440RightIconProduct(item) && +item.LIMIT > 0;
}

export function sortGame440RightIconProducts(productList, gameId) {
  if (+gameId !== 440 || !productList?.length) {
    return productList;
  }

  const topList = [];
  const middleList = [];
  const bottomList = [];

  productList.forEach(item => {
    if (isGame440RightIconProductPinned(item)) {
      topList.push(item);
    } else if (isGame440RightIconProductSoldOut(item)) {
      bottomList.push(item);
    } else {
      middleList.push(item);
    }
  });

  return [...topList, ...middleList, ...bottomList];
}
